// extracted by mini-css-extract-plugin
export var articleCard = "ArticleCard-module--articleCard--6ef68";
export var articleCardContent = "ArticleCard-module--articleCardContent--663ce";
export var articleCardImageContainer = "ArticleCard-module--articleCardImageContainer--4cfa5";
export var categoriesComma = "ArticleCard-module--categoriesComma--c6777";
export var categoriesHyphen = "ArticleCard-module--categoriesHyphen--da0d9";
export var categoryLink = "ArticleCard-module--categoryLink--eddb9";
export var charcoalText = "ArticleCard-module--charcoalText--7511a";
export var container = "ArticleCard-module--container--24d23";
export var expanded = "ArticleCard-module--expanded--781f5";
export var gatsbyLink = "ArticleCard-module--gatsbyLink--98185";
export var imageTag = "ArticleCard-module--imageTag--1f1c3";
export var imageWrapper = "ArticleCard-module--imageWrapper--37a33";
export var largeCard = "ArticleCard-module--largeCard--b8efc";
export var largeCardDescription = "ArticleCard-module--largeCardDescription--60a97";
export var smallCategoryLink = "ArticleCard-module--smallCategoryLink--65b54";